import React, { ReactElement } from 'react';
import styled from 'styled-components';
import AutoTextarea from '@components/dataEntry/textarea/AutoTextarea/index';
import CheckboxBase from './CheckboxStyle';
import SaveIconSec from '@pages/Setting/3.Homepage/common/SaveIconSec';
import DeleteIconSec from '@pages/Setting/3.Homepage/common/DeleteIconSec';
import SwapIconSec from '@pages/Setting/3.Homepage/common/SwapIconSec';
import { DraggableSyntheticListeners } from '@dnd-kit/core';

const Wrapper = styled.div<{
  isChecked: boolean;
  isDragging?: boolean; // 🔧 드래그 상태 추가
}>`
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  width: 100%;
  padding: 4px 0;
  position: relative;
  gap: 4px;
  opacity: ${({ isDragging }) => isDragging ? 0.5 : 1}; // 🔧 드래그 시 투명도 변경

    position: relative;
  label {
    color: ${({ isChecked }) =>
    !isChecked ? 'var(--textColor)' : 'var(--subTextColor)'};
  }

  .swapIcon,
  .xIcon {
    opacity: 0;
  }

  &:hover {
    .swapIcon,
    .xIcon {
      opacity: 1;
    }
  }
    
  &:hover {
    cursor: var(--hoverCursorURL), pointer;
  }
`;

const Label = styled.label`
  transition: all 0.2s;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  height: 100%;

  textarea {
    &::placeholder {
      font-size: 14px;
    }
  }
`;

interface CheckboxProps {
  value: string;
  onChange?: any;
  checkBoxChange?: any;
  checked: boolean;
  name?: string;
  id?: string;
  children?: ReactElement | string | undefined;
  defaultChecked?: boolean;
  disabled?: boolean;
  placeholder?: string;
  isEdit?: boolean;
  handleSave?: any;
  handleDelete?: any;
  dragHandleProps?: DraggableSyntheticListeners;
  isDragging?: boolean;
  autoSave?: boolean;
  onFocus?: React.FocusEventHandler<HTMLTextAreaElement>;
  onCompositionStart?: React.CompositionEventHandler<HTMLTextAreaElement>;
  onCompositionEnd?: React.CompositionEventHandler<HTMLTextAreaElement>;
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
}

function TodoCheckbox({
  checked,
  name,
  disabled,
  value,
  id = value,
  onChange,
  checkBoxChange,
  defaultChecked,
  children,
  placeholder,
  isEdit,
  handleSave,
  handleDelete,
  dragHandleProps,
  isDragging,
  autoSave,
  onFocus,
  onCompositionStart,
  onCompositionEnd,
  onBlur,
  ...props
}: CheckboxProps) {
  if (isEdit) {
    return (
      <>
        <Wrapper isChecked={checked} isDragging={isDragging}>
          <SwapIconSec
            {...dragHandleProps} // 🔧 드래그 핸들 속성을 SwapIcon에만 적용
            style={{
              left: -22,
              height: "auto",
              top: '16px',
              cursor: isDragging ? 'grabbing' : 'grab', // 🔧 드래그 커서 스타일
            }}
          />
          <CheckboxBase
            id={id}
            name={name}
            value={value}
            onChange={checkBoxChange}
            defaultChecked={defaultChecked}
            checked={checked}
            disabled={disabled}
          />
          <Label htmlFor={id}>
            <AutoTextarea
              placeholder={placeholder}
              name={'value'}
              value={value}
              onChange={onChange}
              onFocus={onFocus}
              onCompositionStart={onCompositionStart}
              onCompositionEnd={onCompositionEnd}
              onBlur={onBlur}
              maxLength={10000}
              autoRows
              minRows={1}
              textareaStyle={{
                padding: '0 8px',
                fontSize: 14,
                height: 'auto',
                color: !checked ? 'var(--textColor)' : 'var(--subTextColor)',
              }}
              transparent
            />
          </Label>
          {!autoSave && <SaveIconSec onClick={handleSave} />}
          <DeleteIconSec onClick={handleDelete} />
        </Wrapper>
      </>
    );
  }

  return (
    <Wrapper isChecked={checked} isDragging={isDragging}>
      <CheckboxBase
        id={id}
        name={name}
        value={value}
        defaultChecked={defaultChecked}
        checked={checked}
        disabled={disabled}
      />
      <Label htmlFor={id}>{value}</Label>
    </Wrapper>
  );
}

export default React.memo(TodoCheckbox);
